import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Resources"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "resources"
    }}>{`Resources`}</h1>
    <p>{`Tools, themes, extensions and examples built by the Theme UI community.`}</p>
    <h2 {...{
      "id": "custom-themes"
    }}>{`Custom themes`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/tabetalt/kit"
        }}><strong parentName="a">{`@tabetalt/kit`}</strong></a>{`:
Used in Tabetalt’s e-commerce platform.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme.hackclub.com"
        }}><strong parentName="a">{`@hackclub/theme`}</strong></a>{`:
Used on `}<a parentName="li" {...{
          "href": "https://hackclub.com/"
        }}>{`Hack Club’s`}</a>{` websites.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbonplan/theme"
        }}><strong parentName="a">{`@carbonplan/theme`}</strong></a>{`:
Used on `}<a parentName="li" {...{
          "href": "https://carbonplan.org"
        }}>{`Carbonplan’s`}</a>{` websites.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/UNDataForum/design-system/tree/master/packages/preset"
        }}><strong parentName="a">{`@undataforum/preset`}</strong></a>{`:
Used on `}<a parentName="li" {...{
          "href": "https://undataforum.org/"
        }}>{`United Nations World Data Forum`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/lachlanjc/theme-ui-preset-geist"
        }}><strong parentName="a">{`theme-ui-preset-geist`}</strong></a>{`:
Inspired by/adapted from `}<a parentName="li" {...{
          "href": "https://geist-ui.dev"
        }}>{`Geist UI`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nice-boys/theme-ui-preset-nice-boys"
        }}><strong parentName="a">{`theme-ui-preset-nice-boys`}</strong></a>{`  `}</li>
    </ul>
    <h2 {...{
      "id": "component-kits"
    }}>{`Component kits`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ccontrols/component-controls/tree/master/ui/components"
        }}><strong parentName="a">{`@component-controls/components`}</strong></a>{`:
Components built for Theme UI.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/cartolab-gis/elements"
        }}><strong parentName="a">{`@cartolab/elements`}</strong></a>{`:
Themeable React components for map-based web applications.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbonplan/components"
        }}><strong parentName="a">{`@carbonplan/components`}</strong></a>{`:
Shared React components for `}<a parentName="li" {...{
          "href": "https://carbonplan.org"
        }}>{`Carbonplan`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/UNDataForum/design-system/tree/master/packages/components"
        }}><strong parentName="a">{`@undataforum/components`}</strong></a>{`:
Shared React components for UN Data Forum.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/pixelmord/prestyled"
        }}><strong parentName="a">{`prestyled`}</strong></a></li>
    </ul>
    <h2 {...{
      "id": "theme-previewers"
    }}>{`Theme previewers`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui-gallery.netlify.app"
        }}><strong parentName="a">{`Theme UI Gallery`}</strong></a>{`:
Themed components live previewer.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.skin-ui.com/"
        }}><strong parentName="a">{`Skin UI`}</strong></a>{`:
Theme UI live previewer & code editor.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.oh-my-theme.com/"
        }}><strong parentName="a">{`Oh My Theme`}</strong></a>{`:
Theme UI preset previewer.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://components.ai/theme-ui/"
        }}><strong parentName="a">{`Components.ai Theme Generator`}</strong></a>{`:
Generate, preview, & export random themes.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Palmaswell/controlled-styled-editor"
        }}><strong parentName="a">{`Controlled Styled Editor`}</strong></a>{`:
Edit your React components based on System UI constrained design principles.`}</li>
    </ul>
    <h2 {...{
      "id": "project-templates"
    }}>{`Project templates`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/lachlanjc/next-theme-starter"
        }}><strong parentName="a">{`@lachlanjc/next-theme-starter`}</strong></a>{`:
Next.js project for getting started with MDX & Theme UI.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/hackclub/theme-starter"
        }}><strong parentName="a">{`@hackclub/theme-starter`}</strong></a>{`:
Next.js project using `}<a parentName="li" {...{
          "href": "https://theme.hackclub.com"
        }}>{`Hack Club Theme`}</a>{` & MDX.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/johnpolacek/nextjs-mdx-blog-starter"
        }}><strong parentName="a">{`Next.js MDX Blog Starter`}</strong></a>{`:
Next.js blog starter for building blogs with MDX, Theme UI, & Vercel.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mattjennings/nextjs-starter"
        }}><strong parentName="a">{`@mattjennings/nextjs-starter`}</strong></a>{`:
Next.js project using Theme UI & Framer Motion.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/hew/gatsby-theme-ui-starter"
        }}><strong parentName="a">{`@hew/gatsby-theme-ui-starter`}</strong></a>{`:
Gatsby.js project using Netlify Forms.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/codebushi/gatsby-theme-document"
        }}><strong parentName="a">{`@codebushi/gatsby-theme-document`}</strong></a>{`:
Gatsby.js theme for documentation.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/johno/gatsby-theme-glossary"
        }}><strong parentName="a">{`gatsby-theme-glossary`}</strong></a>{`:
Gatsby.js theme for a glossary to define terminology.`}</li>
    </ul>
    <h2 {...{
      "id": "other-projects"
    }}>{`Other projects`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/samjbmason/theme-ui-native"
        }}><strong parentName="a">{`theme-ui-native`}</strong></a>{`:
Theme UI adapted for React Native projects.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nandorojo/dripsy"
        }}><strong parentName="a">{`Dripsy`}</strong></a>{`:
A responsive, theme-based design system for Expo + React Native Web.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/LekoArts/figma-theme-ui"
        }}><strong parentName="a">{`Theme UI plugin for Figma`}</strong></a>{`:
`}<a parentName="li" {...{
          "href": "https://www.figma.com/c/plugin/797015796747379907"
        }}>{`Figma plugin`}</a>{` to convert a Theme UI config to Figma Styles.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/fabulascode/theme-ui-modifiers"
        }}><strong parentName="a">{`@fabulas/theme-ui-modifiers`}</strong></a>{`:
Library for using BEM-style modifiers on Theme UI components.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mattjennings/react-modal"
        }}><strong parentName="a">{`@mattjennings/react-modal`}</strong></a>{`:
Library for making animated modals with Theme UI & Framer Motion.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-layouts.com/"
        }}><strong parentName="a">{`React Layouts`}</strong></a>{`:
Grab-and-go layouts for React, including Theme UI.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      